<script>
import { notify } from '@/helpers/notify'
import {
   required
} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader.vue";
import SearchableSelect from "@/components/SearchableSelect";

export default {
    name: 'Transfer',
    props:[
        "openModal",
        "data"
    ],
    components: {
        Loader,
        SearchableSelect
    },
   data() {
        return {
            userList:[],
            toList: [],
            groupOptions: [
                { id: 'depo', name: 'Depo' },
                { id: 'verici', name: 'Verici' },
                { id: 'pop', name: 'Pop' },
            ],
            toSubsId: '',
            toTransmitterId: '',
            toTransmitterGroupId: '',
            submitted: false,
            loading:false,
            transferring: false,
            searchModel: '',
            searchResult: [],
            basket: [],
            timeout: null,
            title: 'Transfer',
            fromDepoId: '',
            toGroup: '',
            toId: ''
        };
    },
    watch:{
        toGroup(val, oldVal){
            if (oldVal && oldVal !== val) {
                this.toId = ''
            }
            this.setTitle()
            this.loadToList()
        },
        fromDepoId() {
            if (this.toGroup === 'depo') {
                this.loadToList()
            }
            if (this.searchModel.length >= 2) {
                this.product()
            }
        },
        openModal() {
            this.submitted= false
            this.loading= false
            this.transferring = false
            this.searchModel= ''
            this.searchResult= []
            this.basket = []
            this.toId = ''
            this.fromDepoId = ''
            this.toSubsId = ''
            this.toTransmitterId = ''
            this.toTransmitterGroupId = ''
            this.timeout= null
            this.toGroup = this.data.stoktipi || 'depo'
            this.toId = this.data.id || ''
            this.setTitle()
            this.loadUserList()
            this.loadToList()
        }
    },

    validations: {
        toId: { required },
        fromDepoId: { required },
    },

    methods: {
        setTitle() {
            if (this.toGroup === 'verici') this.title = 'Vericiye Transfer'
            else if (this.toGroup === 'pop') this.title = 'Pop Noktasına Transfer'
            else if (this.toGroup === 'musteri') this.title = 'Müşteriye Transfer'
            else this.title = 'Depolar Arası Transfer'

            if (this.data) {
                this.$set(this.data, 'stoktipi', this.toGroup)
            }
        },
        normalizeOptions(resp) {
            const payload = resp && resp.data
            const list = Array.isArray(payload) ? payload : (payload && payload.data) || []
            return list.map(e => ({ id: e.id, name: e.name })).filter(e => e.id && e.name)
        },
        loadUserList() {
            this.$http.post('/users?output=one&fields=id,name&depo=1')
                .then(response => {
                    const list = Array.isArray(response.data) ? response.data : []
                    this.userList = list.filter(e => e.id != this.data.user_id)
                })
        },
        loadToList() {
            if (this.toGroup === 'verici') {
                this.$http.post('/transmitter?output=one&perPage=500')
                    .then(response => { this.toList = this.normalizeOptions(response) })
                return
            }

            if (this.toGroup === 'pop') {
                this.$http.post('/transmitter/groups?search=1')
                    .then(response => { this.toList = this.normalizeOptions(response) })
                return
            }

            this.$http.post('/users?output=one&fields=id,name&depo=1')
                .then(response => {
                    const list = Array.isArray(response.data) ? response.data : []
                    this.toList = list.filter(e => e.id != this.fromDepoId)
                })
        },
        handleSubmit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) { return }

            if (!this.basket.length) {
                return notify.error('Seçili ürün yok.')
            }

            const postBasketData = this.basket.map(item => {
                return { id: item.id, amount: item.amount };
            });

            let transferData = { basket: postBasketData }

            if (this.toGroup == 'verici') {
                transferData = { ...transferData, toTransmitterId: this.toId}
            }else if (this.toGroup  == 'depo') {
                transferData = { ...transferData, toDepoId: this.toId, fromDepoId: this.fromDepoId }
            } else if (this.toGroup  == 'musteri') {
                transferData = { ...transferData, toSubsId: this.toId}
            } else if (this.toGroup  == 'pop') {
                transferData = { ...transferData, toTransmitterGroupId: this.toId}
            }

            this.transferring = true
            this.$http.post('/stock/depo/transfer', transferData)
            .then(response => {
                if (!response || !response.data) {
                    return notify.error('Sunucudan cevap alınamadı.')
                }
                if (response.data.error) {
                    return notify.error(response.data.message || 'Transfer başarısız.')
                }

                this.searchModel= ''
                this.searchResult= []
                this.basket = []
                this.$emit('loadItems');
                notify.success(response.data.message || 'Transfer tamamlandı', 'top-end', true)
                this.close()
            })
            .catch(() => {
                notify.error('Transfer sırasında hata oluştu.')
            })
            .finally(() => {
                this.transferring = false
                this.submitted = false
            })
        },

        close(){
            this.$parent.$bvModal.hide('transfer')
        },

        debouncedProduct() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            this.timeout = setTimeout(() => {
                this.product();
            }, 400);
        },

        product() {
            this.searchResult = []
            if (this.searchModel.length < 2) return
            if (!this.fromDepoId) return notify.error('Önce kaynak depo seçiniz.')

            this.loading = true

            let transferData = { search: this.searchModel, depo_id: this.fromDepoId }

            this.$http.post('stock', transferData).then((data) => {
                this.loading = false
                if (data.data.length == 0) {
                    return notify.error('Stokta ürün bulunmamaktadır.')
                }
                this.searchResult = data.data
           }).catch(() => {
                this.loading = false
                notify.error('Ürün aranamadı.')
           });
        },

        addBasket(sr) {
            this.searchModel = ''
            this.searchResult= []
            this.basket.push(sr)
        },

        removeLine(idx) {
            this.basket.splice(idx, 1);
        }
  },
};
</script>

<template>
  <b-modal
        id="transfer"
        :title="title"
        no-close-on-backdrop
        size="xl"
        hide-footer>


        <div class="row mb-3">
            <label class="col-sm-12 col-form-label">Nerden Transfer</label>
            <div class="col-12">
                <SearchableSelect
                    v-model="fromDepoId"
                    :options="userList"
                    label="name"
                    :reduceFn="o => o.id"
                    placeholder="Depo ara / seçiniz"
                    searchable
                    :class="{ 'is-invalid': submitted && $v.fromDepoId.$error }"
                />
                <div
                    v-if="submitted && !$v.fromDepoId.required"
                    class="invalid-feedback d-block"
                >
                    Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>

        <div class="row text-center">
            <label class="col-sm-12 col-form-label text-capitalize">Transfer Edilecek Cihaz/Malzemeler Ara</label>
            <div class="col-12">
                <Loader :loading="true" :load="loading">
                    <table class="table table-sm table-hovered" style="border: solid 1px #ced4da;">
                        <thead>
                            <tr>
                                <td colspan="3">
                                    <input
                                    class="form-control"
                                    type="text"
                                    v-model="searchModel"
                                    placeholder="Barkod veya ürün adı ara"
                                    @keyup="debouncedProduct">
                                </td>
                            </tr>
                        </thead>
                        <tbody v-if="searchResult.length > 0">
                            <tr v-for="(sr,i) in searchResult" :key="i">
                                <td style="width:50px">
                                    <button type="button" @click="addBasket(sr)" class="btn btn-sm btn-success">Seç</button>
                                </td>
                                <td>{{  sr.name }}</td>
                                <td>{{  sr.stock_group_name }} - <strong>{{  sr.user_name }}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </Loader>
            </div>
        </div>


        <div class="row mb-1 mt-3" v-if="basket.length > 0">
            <div class="col-12 mb-1">
                <h6 class="mb-2">Seçilen Cihaz/Malzemeler</h6>
                <div class="row">
                    <div class="col-12">
                        <table class="table table-sm table-hover table-bordered">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Stok İsim</th>
                                    <th>Seri No</th>
                                    <th style="width: 200px;">Adet</th>
                                    <th style="width: 40px;" class="text-center"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(sr,i) in basket" :key="i">
                                    <td>{{ i+1 }}</td>
                                    <td>{{ sr.stock_group_name }}</td>
                                    <td>{{ sr.name }}</td>
                                    <td>
                                        <input v-if="sr.group_id == 'ka' || sr.group_id == 'sm' || sr.group_id == 'si'" type="number" v-model="sr.amount" style="width:140px" class="form-control">
                                        <span v-else>1</span>
                                    </td>
                                    <td>
                                        <button type="button" class="btn btn-danger btn-sm" @click="removeLine(i)">X</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>


        <div class="row text-center">
            <div class="col-md-12">
               <i style="font-size:2.5rem" class="text-primary mdi mdi-transfer-down"></i>
            </div>
        </div>


        <div class="row text-center" v-if="data.nereye">
            <label class="col-sm-12 col-form-label" for="depo">Nereye Transfer Edilecek</label>
            <div class="col-sm-12">
                {{ data.nereye }}
            </div>
        </div>

       <div class="row" v-else>
            <label class="col-sm-12 col-form-label" for="depo">Nereye Transfer Edilecek</label>
            <div class="col-md-4 mb-2">
                <SearchableSelect
                    v-model="toGroup"
                    :options="groupOptions"
                    label="name"
                    :reduceFn="o => o.id"
                    placeholder="Hedef tipi"
                    searchable
                />
            </div>
            <div class="col-md-8 mb-2">
                <SearchableSelect
                    v-model="toId"
                    :options="toList"
                    label="name"
                    :reduceFn="o => o.id"
                    placeholder="Hedef ara / seçiniz"
                    searchable
                    :class="{ 'is-invalid': submitted && $v.toId.$error }"
                />
                <div
                    v-if="submitted && !$v.toId.required"
                    class="invalid-feedback d-block"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                :disabled="transferring"
                @click="handleSubmit"
                >{{ transferring ? 'Aktarılıyor...' : 'Transfer Et' }}
            </b-button>
        </div>
</b-modal>
</template>
